import React, { useEffect, useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import MoffTrainingRecordForm from '../../components/Records/MoffTraining/MoffTrainingRecordForm';
import * as RecordActions from '../../actions/Records/actions';
import * as UserActions from '../../actions/User/actions';
import { TRAINING_MENUS } from '../../constants/Records';
import { RootState } from '../../store/configureStore';
import { MoffTrainingRecord } from '../../constants/Records';
import Loading from '../../components/common/Loading';

interface RouteParams {
  institutionId: string;
  userId: string;
}

interface StateProps {
  institution: any;
  userListData: any[];
  mofftraining: any;
}

interface DispatchProps {
  recordActions: typeof RecordActions;
  userActions: typeof UserActions;
}

type Props = StateProps & DispatchProps;

const MoffTrainingRecordCreateContainer: React.FC<Props> = ({
  institution,
  userListData,
  mofftraining,
  recordActions,
  userActions,
}) => {
  const { institutionId, userId } = useParams<RouteParams>();
  const userFetchedRef = useRef(false);

  const user = userListData.find((u: any) => u.user_id === userId);

  // ユーザーデータがない場合は取得
  useEffect(() => {
    if (userListData.length === 0 && !userFetchedRef.current && institutionId) {
      userFetchedRef.current = true;
      userActions.getUsersWithUniqueId(institutionId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [institutionId, userListData.length]);

  const handleFetchRecord = useCallback(
    (id: string, trainingId: number) => {
      recordActions.fetchMoffTrainingRecord(id, trainingId);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const handleCreate = useCallback(
    (id: string, data: Partial<MoffTrainingRecord>, instructorName?: string) => {
      recordActions.createMoffTrainingRecord(id, data, instructorName);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const handleUpdate = useCallback(
    (id: string, startedAt: string, data: Partial<MoffTrainingRecord>) => {
      recordActions.updateMoffTrainingRecord(id, startedAt, data);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const handleResetFlags = useCallback(() => {
    recordActions.resetMoffTrainingFlags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!user) {
    return <Loading />;
  }

  return (
    <MoffTrainingRecordForm
      institutionId={institutionId}
      institutionName={institution?.institution_name || ''}
      userId={userId}
      userName={user.user_name}
      uniqueId={user.user_id || ''}
      menus={TRAINING_MENUS}
      currentRecord={null}
      isEdit={false}
      executing={mofftraining.executing}
      created={mofftraining.created}
      updated={mofftraining.updated}
      onFetchRecord={handleFetchRecord}
      onCreate={handleCreate}
      onUpdate={handleUpdate}
      onResetFlags={handleResetFlags}
    />
  );
};

function mapStateToProps(state: RootState): StateProps {
  return {
    institution: state.institution.institution,
    userListData: state.user.listData,
    mofftraining: state.records.mofftraining,
  };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
  return {
    recordActions: bindActionCreators(RecordActions, dispatch),
    userActions: bindActionCreators(UserActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MoffTrainingRecordCreateContainer);
